module.exports = __webpack_public_path__ + "img/joanna_erdman_expert_exchanges_credit_likhaan_1.ddd0ff0c.jpg";